import { FC, useContext, useEffect, useState } from "react"

import { Table } from "@/components/_Shared/Table"
import { Resource } from "@/constants/permission"
import { CustomerContext } from "@/context/CustomerContext"

import { financeDocumentColumns } from "./FinanceDocumentColumns"
import { useFinanceDocumentFilters } from "./FinanceDocumentFilters"

import { useFinanceDocumentQuery } from "@/hook/useFinanceDataRecordQuery"
import { useTable } from "@/hook/useTable"

import { FINANCE_DOCUMENT_KEY, FinanceDocumentTypeKeys, FinanceDocumentTypeTabs } from "@/types/IFinanceDataRecord"

import { getInitialColumns } from "@/utils/getInitialColumns"


const FinanceDocumentsPage: FC = () => {
  const storageKey = FINANCE_DOCUMENT_KEY

  const userContext = useContext(CustomerContext)
  const isCustomer = userContext?.isCustomer()
  const [customerId, setCustomerId] = useState<number | null>(null)

  const { columns, pagination, filter, order } = useTable({
    initialColumns: getInitialColumns([...financeDocumentColumns], FINANCE_DOCUMENT_KEY),
    key: FINANCE_DOCUMENT_KEY
  })

  const { data, isLoading } = useFinanceDocumentQuery(
    {
      Page: pagination.page,
      PageSize: pagination.pageSize,
      Filter: filter.filter,
      OrderBy: order.orderBy
    },
    customerId
  )

  const { filters } = useFinanceDocumentFilters()

  useEffect(() => {
      const customerId = userContext?.customer?.id
      if (isCustomer && customerId) {
          setCustomerId(customerId)
      }
  }, [userContext])

  return (
    <>
      <Table
        tableTitle="Документы"
        dataSource={data?.response.data}
        columns={columns.data}
        rowKey="id"
        isLoading={isLoading}
        pagination={{
          currentPage: pagination.page,
          pageSize: pagination.pageSize,
          total: data?.response.count,
          onPageChange: pagination.onPageChange,
          onPageSizeChange: pagination.onPageSizeChange
        }}
        filters={{
          filters: filters,
          onSubmit: filter.onFilterChange,
          onCancel: filter.onFilterReset,
          filterKey: storageKey
        }}
        onSorterChange={order.setOrderBy}
        isSelectable={false}
        permission={{
          resource: Resource.FinanceDocuments
        }}
        tabItemsFilterName={"documentType"}
        statusTabs={{
          defaultActiveKey: FinanceDocumentTypeKeys.All,
          items: FinanceDocumentTypeTabs
        }}
        hasDateFilter={true}
      />
    </>
  )
}

export default FinanceDocumentsPage